<template>
  <div>
    <v-sheet color="white">
      <v-progress-linear color="primary" v-show="loading"></v-progress-linear>
      <span class="caption d-flex justify-start ml-3">
        {{selectedorder.PARTYMST_DESC}}
      </span>
      <v-simple-table dense>
        <template v-slot:default>
          
          <thead>
            <tr>
              <th class="text-left caption" style="width:15%">
               SM Code
              </th>
              <th class="text-left caption" style="width:45%">
                Item Name
              </th>
              <th class="text-left caption" style="width:8%">
                Qty
              </th>
              <th class="text-left caption" style="width:9%">
                Unit
              </th>
              <th class="text-left caption" style="width:9%">
                Rate
              </th>
              <th class="text-left caption" style="width:9%">
                Gross Amt
              </th>
               <th class="text-left caption" style="width:5%">
                EDD
              </th>

            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in salesorderitems"
              :key="item.SALDET_DOCSRNO"
            >
              <td>{{ item.SALDET_STOCK_DOCNO }}</td>
              <td>{{ item.SALDET_STOCK_DESC }}</td>
              <td class="text-right">{{ item.SALDET_QTY }}</td>
              <td>{{ item.SALDET_UNIT_DOCNO }}</td>
              <td class="text-right">{{ item.SALDET_RATE }}</td>
              <td class="text-right">{{ item.SALDET_GROSS_AMOUNT }}</td>
              <td class="text-right">{{ item.SALDET_EXPECTED_DELIVERY_DATE.slice(4, 16)}}</td>
              
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "Orderitems",
  props:{
    salesorder:{
        type: Object,
        default:(()=>{})
    }
  },
  data() {
    return {};
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    selectedorder() {
      return this.$store.getters.selectedorder;
    },
    salesorderitems(){      
      return this.$store.getters.salesorderitems;      
    },  
  },
  mounted() {
    // console.log(this.salesorderitems);
  },
};
</script>

<style scoped></style>